import React from 'react'
import { ListItem } from '@material-ui/core'

const User = ({ user }) => {
  return (
    <ListItem key={`userListItem${user.user_name}`} button>
      {user.user_name}
    </ListItem>
  )
}

export default User
